import { FC, memo } from 'react';
import styled from 'styled-components';

import { DefaultTitle } from '@components/text/Title';

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  text-align: center;
`;

const Following: FC = () => {
  return (
    <Container>
      <Body>
        <DefaultTitle>People You Follow</DefaultTitle>
      </Body>
    </Container>
  );
};

export default memo(Following);
